export class BaseModel<T> {

  constructor(data: T) {
    Object.assign(this, data);
  }
}
